import { EMPLOYEE_BASE_URL } from "src/redux/api/appConst";
import { axiosAuth } from "src/redux/api/common";

export const getResignation = async () => {
  const api = axiosAuth(EMPLOYEE_BASE_URL);

  const { data } = await api.get(`/resignations`);

  return data.data.resignations;
};
